import { DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Component = styled(DialogActions, {
  label: "popup-actions",
})`
  margin: ${({ theme }) => theme.spacing(3, "auto")};

  & > button {
    margin: 0;
  }
`;
